import {findIndex} from "lodash";
import {Directory} from "mapping/directory";
import {generateFullUrl, getVimeoIdFromUrl} from "services/utils/utils";
import {Speaker} from "mapping/speaker";
export const Video = {
    fromServer: (data) => {
        const rawVideo = data.video;
        const userStats = data.user_stats;
        const unlocked = data.unlocked;
        const has_directory = !!data.directory;
        const video = {
            id: rawVideo.id,
            title: rawVideo.title,
            tags: data.tags,
            created_at: rawVideo.created_at,
            favorite: userStats.favorite,
            requires_payment: !unlocked.status,
            cost: rawVideo.cost,
            min_level: unlocked.plan,
            categories: data.categories,
            image: generateFullUrl(rawVideo.background),
            description: rawVideo.description,
            speakers: data.speakers.map(Speaker.fromServer),
            material: rawVideo.links,
            video_id: rawVideo.url ? getVimeoIdFromUrl(rawVideo.url) : null,
            progress: userStats.current,
            duration: rawVideo.duration,
            likes: {
                total: data.likes,
                avatars: data.lastLikesAvatars.map(generateFullUrl)
            },
            like: userStats.liked,
            has_directory,
            type: rawVideo.type
        }
        if (video.has_directory) {
            video.directory = Directory.fromServer(data.directory);
            video.directory_index = findIndex(video.directory.videos, i => i.id === video.id);
        }
        return video;
    },
    toServer: (data) => {
        return {
            ...data
        }
    }
}